export const escapeFacetFilterValue = (value) => {
    const stringValue = String(value);
    return stringValue.startsWith('-') ? `\\${stringValue}` : stringValue;
};

export const buildFacetFilters = (sourceFilters = {}) => {
    return Object.keys(sourceFilters)
        .filter(key => sourceFilters[key] && sourceFilters[key].length > 0)
        .map(key => {
            const facetGroup = sourceFilters[key].map(value => `${key}:${escapeFacetFilterValue(value)}`);
            return facetGroup.length > 1 ? facetGroup : facetGroup[0];
        });
};

export const createFacetFiltersFromFilterExpression = (filterExpression = '') => {
    if (!filterExpression) {
        return [];
    }

    const parsedFilters = {};
    const categoryGroups = filterExpression.split(' AND ');

    categoryGroups.forEach(group => {
        const cleanGroup = group.replace(/^\(|\)$/g, '');
        const orFilters = cleanGroup.split(' OR ');

        orFilters.forEach(filter => {
            const colonIndex = filter.indexOf(':');
            if (colonIndex <= 0) {
                return;
            }

            const key = filter.substring(0, colonIndex).trim();
            let value = filter.substring(colonIndex + 1).trim();
            value = value.replace(/^['"]|['"]$/g, '');

            if (!parsedFilters[key]) {
                parsedFilters[key] = [];
            }

            if (!parsedFilters[key].includes(value)) {
                parsedFilters[key].push(value);
            }
        });
    });

    return buildFacetFilters(parsedFilters);
};